import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Box, Button, Card, CardContent, Typography } from '@mui/material'
import { ArrowLeftCircle, Save } from 'react-feather'

import { useFechInitForm } from './hooks'
import { 
    DateChangeSection,
    DepositRefundSection,
    ExtensionOfTermSection,
    PaymentExemptionSection,
    BalanceInformationSection,
    ExpenseExemptionSection
} from './Sections'
import {
    FieldContract,
    InfoContract,
    FieldManagementType,
    ApprovalManagement,
    ObservationsContract
} from './Common'
import { ModalModule } from './ModalModule'

export const FormManagement = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFechInitForm({location, paramsURL})

    const {
        globalStates,
        FetchData,
        Forms,
        Helpers,
        defaultData,
        Actions
    } = useFetchInit

    const { identifySelectedRequestType } = Helpers

    const { FormRequestGlobal } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormRequestGlobal

    const { handleChangeContract, handleClickCloseForm, onSubmitFormRequests, onSendLogs } = Actions

    const { fetchAllTypeManagements, fetchInfoObservations } = FetchData
    const { typeManagements } = fetchAllTypeManagements
    const { observations } = fetchInfoObservations

    const { showFormContract } = globalStates


    return (
        <AllowedAccess permissions={['133_ARRENDAMIENTOS_GESTIONES']} renderAuthFailed={<p>Error</p>}>
            <ModalModule useFetchInit={useFetchInit} />
            <div className='panel-body'>
                <form onSubmit={onSubmitFormRequests}>
                    <Card style={{zIndex:'1'}}>
                        <CardContent>
                        <Typography sx={{color:'warning.main'}} variant='overline' >
                            * campos obligatorios
                        </Typography>
                        
                        <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                            Informacion sobre el contrato
                        </Typography>
                        <div className="border-bottom border-dark"></div>
                        <FieldContract
                            formState={formState}
                            handleChangeContract={handleChangeContract}
                            FetchData={FetchData}
                            readOnly={true}
                        />
                        {showFormContract && (
                            <InfoContract 
                                formState={formState}
                                FetchData={FetchData}
                            />
                        )}

                        <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                            Informacion sobre la gestion
                        </Typography>
                        <div className="border-bottom border-dark"></div>
                        <FieldManagementType
                            formState={formState}
                            onSelectSearchChange={onSelectSearchChange}
                            FetchData={FetchData}
                            readOnly={true}
                        />

                        {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'CFP' && (
                            <DateChangeSection useFetchInit={useFetchInit} />
                        )}

                        {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'DDP' && (
                            <DepositRefundSection useFetchInit={useFetchInit} />
                        )}

                        {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'ADP' && (
                            <ExtensionOfTermSection useFetchInit={useFetchInit} />
                        )}

                        {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'EXP' && (
                            <PaymentExemptionSection useFetchInit={useFetchInit} />
                        )}

                        {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'FNO' && (
                            <BalanceInformationSection useFetchInit={useFetchInit} />
                        )}
                        
                        {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'FEX' && (
                            <BalanceInformationSection useFetchInit={useFetchInit} />
                        )}
                        
                        {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'FAB' && (
                            <BalanceInformationSection useFetchInit={useFetchInit} />
                        )}
                        
                        {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'EXG' && (
                            <ExpenseExemptionSection useFetchInit={useFetchInit} />
                        )}

                        <ApprovalManagement
                            formState={formState}
                            optionsAprobacionCheck={defaultData.optionsAprobacionCheck}
                            onSelectSearchChange={onSelectSearchChange}
                        />

                        {(formState.idgestion>0) && (
                            <ObservationsContract
                            formState={formState}
                            onInputChange={onInputChange}
                            onSendLogs={onSendLogs}
                            observations={observations}
                            />
                        )} 

                        <Box className="text-center" sx={{mt: 2}}>
                            <Button 
                                startIcon={<ArrowLeftCircle/>}
                                variant="contained"
                                type="button" 
                                className='btn-round'
                                color='warning'
                                onClick={handleClickCloseForm} 
                                sx={{ marginRight: 1, marginLeft: 1 }}
                            >
                                Volver
                            </Button>
                            <Button
                                endIcon={<Save/>}
                                variant="contained"
                                className='btn-round'
                                color='primary'
                                type='submit'
                                sx={{ marginRight: 1, marginLeft: 1 }}
                            >
                            Enviar Gestion
                            </Button>
                        </Box>
                        </CardContent>
                    </Card>
                </form>
            </div>
        </AllowedAccess>
    )
}
